<b-tabs content-class="mt-3" justified>
	<b-tab title="4-Look Last Layer" active>
		<b-container fluid>
			<h1>1st look</h1>
			<b-row>
				<algorithm-component
					v-for="alg in intermediateAlgorithmsFirst"
					:algName="alg.name"
					:steps="alg.steps" />
			</b-row>
		</b-container>
		<b-container fluid>
			<h1>2nd look</h1>
			<b-row>
				<algorithm-component
					v-for="alg in intermediateAlgorithmsSecond"
					:algName="alg.name"
					:steps="alg.steps" />
			</b-row>
		</b-container>
		<b-container fluid>
			<h1>3rd look</h1>
			<b-row>
				<algorithm-component
					v-for="alg in intermediateAlgorithmsThird"
					:algName="alg.name"
					:steps="alg.steps" />
			</b-row>
		</b-container>
		<b-container fluid>
			<h1>4th look</h1>
			<b-row>
				<algorithm-component
					v-for="alg in intermediateAlgorithmsFourth"
					:algName="alg.name"
					:steps="alg.steps" />
			</b-row>
		</b-container>
	</b-tab>
</b-tabs>
